// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"295":"9d78c252","388":"63d2ba32"}[chunkId] || chunkId) + "." + {"295":"6a56a178982cdee5","388":"2dce49acf761a7ac","730":"a5100f92c552d8cd"}[chunkId] + ".js";
};